import adminClients from './admin-clients.routes';
import adminProfile from './admin-profile.routes';
import adminProfiles from './admin-profiles.routes';
import adminMantle from './admin-mantle.routes';

import companiesChannels from './companies-channels.routes';
import companiesSectors from './companies-sectors.routes';
import companiesCompanies from './companies-companies.routes';
import companiesCompany from './companies-company.routes';
import companiesPlaceDetails from './companies-place-details.routes';
import companiesSites from './companies-sites.routes';
import aggregations from './aggregations.routes';
import managementServiceBus from './management-servicebus.routes';
import managementAuditActions from './management-audit-actions.routes';

import reviewsDatashake from './reviews-datashake.routes';
import reviewsFetchprofiles from './reviews-fetchprofiles.routes';
import reviewsProfiles from './reviews-profiles.routes';
import reviewsReviews from './reviews-reviews.routes';
import reviewsReview from './reviews-review.routes';
import reviewsSchedules from './reviews-schedules.routes';

export default {
    adminClients,
    adminProfile,
    adminProfiles,
    adminMantle,
    companiesChannels,
    companiesSectors,
    companiesCompany,
    companiesCompanies,
    companiesPlaceDetails,
    companiesSites,
    aggregations,
    managementServiceBus,
    managementAuditActions,
    reviewsDatashake,
    reviewsFetchprofiles,
    reviewsProfiles,
    reviewsReviews,
    reviewsReview,
    reviewsSchedules
};
